export default __webpack_public_path__ + "static/media/delta_gov.6ebbe587.png";